<template>
    <span style="display: block">
        {{ `${description} ${amount} ${currency}` }}
    </span>
</template>

<script>
export default {
    name: 'invoice-row',
    props: {
        article: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: false
        },
        amount: {
            type: Number,
            required: true
        },
        currency: {
            type: String,
            required: true
        },
    }
}
</script>
